import React from 'react';
import PropTypes from 'prop-types';

import { AppConsumer } from 'providers/app-provider';

import GoogleSignInButton from 'containers/common/google-sign-in-button';

const propTypes = {
  mounted: PropTypes.bool,
  isWebView: PropTypes.bool,
  redirectURI: PropTypes.string,
  marketingAllowed: PropTypes.bool,
};

const defaultProps = {
  mounted: false,
  isWebView: false,
  redirectURI: null,
  marketingAllowed: false,
};

export const ConnectedSignIn = ({ mounted, isWebView, redirectURI, marketingAllowed }) => {
  if (!mounted || isWebView) { return null; }

  return (
    <div className="form-section">
      <div className="divider-style-dashed divider-width-1 divider-color-medium-gray divider-content-or" />
      <div className="center-block padding-vertical-20 google-sign-in-wrapper">
        <GoogleSignInButton
          buttonID="sign-up-button"
          signOut
          redirectURI={redirectURI}
          marketingAllowed={marketingAllowed}
        />
      </div>
      <div className="divider-style-dashed divider-width-1 divider-color-medium-gray" />
    </div>
  );
};
ConnectedSignIn.propTypes = propTypes;
ConnectedSignIn.defaultProps = defaultProps;

const ConnectedSignInWrapper = props => (
  <AppConsumer>
    <ConnectedSignIn {...props} />
  </AppConsumer>
);

export default ConnectedSignInWrapper;
